// Editorial hero: the image sits on top of the page as a rounded card inside the
// page column, with the title anchored to its bottom-left corner over a soft
// gradient, rather than a full-bleed banner with centered copy.
export const HERO_BANNER_STYLES = {
  root: "w-full px-4 pt-4 md:px-8 md:pt-6",
  frame: "relative mx-auto w-full max-w-7xl",
  imageWrapper:
    "group relative aspect-[4/5] w-full overflow-hidden rounded-[24px] bg-ticketon-dark-blue shadow-component sm:aspect-[3/2] md:aspect-[21/9] md:rounded-[32px]",
  image: "absolute inset-0 h-full w-full object-cover",
  overlay:
    "absolute inset-0 bg-gradient-to-t from-black/75 via-black/25 to-black/5",
  content:
    "absolute inset-x-0 bottom-0 flex flex-col items-start gap-3 p-6 text-left text-white sm:p-8 md:p-12",
  logo: "h-10 w-auto drop-shadow-md md:h-12",
  title:
    "max-w-4xl text-[36px] font-bold leading-[1.05] tracking-tight drop-shadow-md sm:text-[48px] md:text-[60px] lg:text-[72px]",
  subtitle:
    "max-w-2xl text-[16px] font-normal leading-snug text-white/90 sm:text-[18px] md:text-[20px]",
  navButton:
    "absolute top-1/2 z-10 hidden h-11 w-11 -translate-y-1/2 items-center justify-center rounded-full bg-white/90 shadow-lg backdrop-blur-sm transition-shadow duration-200 hover:shadow-xl md:flex",
  prevButton: "left-6",
  nextButton: "right-6",
  navIcon: "h-3.5 w-3.5 text-ticketon-dark-blue",
  dots: "absolute right-6 top-6 z-10 flex items-center gap-1.5",
  dot: "h-1.5 w-1.5 rounded-full bg-white/50 transition-all duration-200",
  dotActive: "w-5 bg-white",
} as const;
